import { ErrorObject } from '@qpr/client-library/dist/esm/ErrorContext';

export interface HighchartsState {
  data: Data[];
  error?: ErrorObject;
}

export interface Data {
  id: string;
  name: string;
  link?: string;
  informationItems?: Data[];
}

const initialState = {
  data: []
} as HighchartsState;

export default initialState;
